var _circle, _path, _rect, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTeams = function SvgTeams(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 11,
    r: 5,
    fill: "#7B83EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7B83EB",
    d: "M8 19.5c0-2.6 3.2-4.2 8.5-4.2s8.5 1.6 8.5 4.2v6.8c0 1.9-1.6 3.4-3.5 3.4h-10c-1.9 0-3.5-1.5-3.5-3.4z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 26,
    x: 22,
    y: 11,
    fill: "#5059C9",
    rx: 3.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.6,
    d: "M27 18.2h10M32 18.2V31"
  })));
};
export default SvgTeams;